import { createBrowserRouter } from "react-router-dom";
import { browserRoutes } from "./BrowserRoutes";


export const router = createBrowserRouter([...browserRoutes()]);
